var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsds({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5375_151349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20.0001C15.5228 20.0001 20 15.5229 20 10.0001C20 4.47721 15.5228 6.10352e-05 10 6.10352e-05C4.47715 6.10352e-05 0 4.47721 0 10.0001C0 15.5229 4.47715 20.0001 10 20.0001Z",
    fill: "#FCFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57031 10.0001H20.0051C20.0051 9.09749 19.8848 8.22311 19.6606 7.39136H9.57031V10.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57031 4.78217H18.5373C17.9252 3.78327 17.1425 2.90034 16.2299 2.17346H9.57031V4.78217Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0022 20.0001C12.3557 20.0001 14.5188 19.1866 16.227 17.8262H3.77734C5.48555 19.1866 7.64871 20.0001 10.0022 20.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4709 15.2166H18.5354C19.0269 14.4147 19.408 13.5381 19.6587 12.6079H0.347656C0.59832 13.5381 0.979453 14.4147 1.4709 15.2166Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63219 1.5617H5.54348L4.69582 2.17752L5.01961 3.17397L4.17199 2.55815L3.32437 3.17397L3.60406 2.31315C2.85773 2.93483 2.20359 3.66319 1.66453 4.47475H1.95652L1.41695 4.86674C1.33289 5.00698 1.25227 5.14944 1.175 5.29401L1.43266 6.08701L0.951953 5.73776C0.832461 5.99092 0.723164 6.24979 0.624922 6.51405L0.908789 7.3878H1.95652L1.10887 8.00362L1.43266 9.00006L0.585039 8.38424L0.0773047 8.75315C0.0264844 9.16166 0 9.57776 0 10.0001H10C10 4.47725 10 3.82615 10 6.10352e-05C8.02453 6.10352e-05 6.18301 0.573108 4.63219 1.5617ZM5.01961 9.00006L4.17199 8.38424L3.32437 9.00006L3.64816 8.00362L2.80051 7.3878H3.84824L4.17199 6.39135L4.49574 7.3878H5.54348L4.69582 8.00362L5.01961 9.00006ZM4.69582 5.09057L5.01961 6.08701L4.17199 5.47119L3.32437 6.08701L3.64816 5.09057L2.80051 4.47475H3.84824L4.17199 3.4783L4.49574 4.47475H5.54348L4.69582 5.09057ZM8.60656 9.00006L7.75895 8.38424L6.91133 9.00006L7.23512 8.00362L6.38746 7.3878H7.4352L7.75895 6.39135L8.0827 7.3878H9.13043L8.28277 8.00362L8.60656 9.00006ZM8.28277 5.09057L8.60656 6.08701L7.75895 5.47119L6.91133 6.08701L7.23512 5.09057L6.38746 4.47475H7.4352L7.75895 3.4783L8.0827 4.47475H9.13043L8.28277 5.09057ZM8.28277 2.17752L8.60656 3.17397L7.75895 2.55815L6.91133 3.17397L7.23512 2.17752L6.38746 1.5617H7.4352L7.75895 0.565256L8.0827 1.5617H9.13043L8.28277 2.17752Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5375_151349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsds);
export default __webpack_public_path__ + "static/media/usds.279e28f6fe7a7b28070862bffb885bd4.svg";
export { ForwardRef as ReactComponent };